import { render } from "./addSubject.vue?vue&type=template&id=728a3516&scoped=true"
import script from "./addSubject.vue?vue&type=script&lang=js"
export * from "./addSubject.vue?vue&type=script&lang=js"

import "./addSubject.vue?vue&type=style&index=0&id=728a3516&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728a3516"]])

export default __exports__